import LocalStorage from './local-storage'
import GuestContext from '@/auth/guest-context'
import UserContext from '@/auth/user-context'

import { KEYS } from '../data-keys'

/**
 * Local storage gateway for Context data.
 * @export ContextStorage
 * @class ContextStorage
 */
export default class ContextStorage extends LocalStorage {

    /**
     * Creates an instance of ContextStorage.
     * @memberof ContextStorage
     */
    constructor(useSessionStorage = false) {
        super({
            keys: [ KEYS.context ],
            useSessionStorage,
        })
    }

    /**
     * Gets the selected context from local storage if there is one.
     *
     * @returns {Promise<UserContext|GuestContext>} The value.
     */
    async getAsync() {
        let value = await this.getValueAsync(KEYS.context)
        if (value == null) {
            value = GuestContext.fromStoreJson(value)
            await this.upsertAsync(value)
        } else if (value.type === 'guest') {
            value = GuestContext.fromStoreJson(value)
        } else {
            value = UserContext.fromStoreJson(value)
        }

        return value
    }

    /**
     * Inserts or updates Context data to local storage.
     *
     * @param {GuestContext|UserContext} context
     * @returns {Promise<Object>} The upserted data, adjusted to store.
     */
    async upsertAsync(context) {
        const cxtResult = await this.upsertDataAsync(KEYS.context, context)
        return cxtResult ? context : null
    }
}
